<p-tabView class="holding-tabs" *ngIf="holding && filters">
  <p-tabPanel header="Professionals">
    <!-- <app-professionals-table *ngIf="filters" #professionalsTable [filters]="filters"></app-professionals-table>-->
    <app-professionals-multiple [holding]="holding"></app-professionals-multiple>
  </p-tabPanel>
  <p-tabPanel header="Structure">
    <app-holding-structure [holding]="holding"></app-holding-structure>
  </p-tabPanel>
</p-tabView>
